import { render, staticRenderFns } from "./BzSearch.vue?vue&type=template&id=7018cc7a"
import script from "./BzSearch.vue?vue&type=script&lang=js"
export * from "./BzSearch.vue?vue&type=script&lang=js"
import style0 from "./BzSearch.vue?vue&type=style&index=0&id=7018cc7a&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports